import { useState } from "react";
import { useSession } from "../../../context/SessionContext";
import useModal from "../../../hooks/useModal";
import ExpandedCell from "../../atoms/ExpandedCell";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../molecules/NoData";
import Modal from "../../molecules/Modal";
import EditQYR from "../inmueble/inmuebleDocsTables/quejas_reportes/EditQYR";

const QyRAllTable = ({ data, refetch, loading, inmuebles }) => {
    const { user } = useSession();
    const [selected, setSelected] = useState(null);
    const { open, isOpen, close } = useModal();

    const getInmuebleName = (propertieId) => {
        const inmueble = inmuebles?.find((item) => item.id === propertieId);
        return inmueble ? inmueble.name : "Inmueble desconocido";
    };

    const handleOpenResolve = (row) => {
        open();
        setSelected(row);
    };

    const handleClose = () => {
        close();
        setSelected(null);
    };

    const columns = [
        {
            name: "Inmueble",
            selector: (row) => getInmuebleName(row.propertieId),
        },
        {
            name: "Queja/reporte",
            cell: (row) => (
                <div className="flex flex-col">
                    <strong> {row.description} </strong>
                    <ExpandedCell text={row.comment_user} />
                </div>
        ),},
        {
            name: "Fecha de reporte",
            cell: (row) => (
                <div>
                    <strong className={`${row.service_date ? "bg-green-500" : "bg-red-500"} rounded-md p-2 text-white font-bold`}> {row.incident_date} </strong>
                </div>
        ),},
        {
            name: "Fecha de resolución",
            cell: (row) => (
                <button onClick={row.service_date ? null : () => handleOpenResolve(row)}>
                    <strong className={`${row.service_date ? "bg-green-500" : "bg-red-500"} rounded-md p-2 text-white font-bold`}>
                        {row.service_date ? row.service_date : (user?.role !== "Resident" ? "Resolver" : row.status)}
                    </strong>
                </button>
        ),},
        {
            name: "Comentarios del servicio",
            cell: (row) => <ExpandedCell text={row.comment_admin} />,
        },
    ];

    return (
        <>
            <DataTable
                data={data}
                progressPending={loading}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData />}
                pagination
            />
            {isOpen && selected !== null &&
                <Modal title="Editar inmueble" onClose={handleClose}>
                    <EditQYR QOR={selected} refetch={refetch} onClose={handleClose} />
                </Modal>
            }
        </>
    );
};

export default QyRAllTable;
